import React, { useEffect, useState } from 'react';
import axios from 'axios';
import ReactJson from 'react-json-view';
import Skeleton from './common/Skeleton';

const RepositoriesView = ({ repoName, sbomId }) => {

  
  const reposUrl = `http://localhost:8080/sbom/${repoName}/${sbomId}-sbom.json/package/repositories`;
  const [repositoriesData, setRepositoriesData] = useState(null);
  const [isCollapsed, setIsCollapsed] = useState(false);
  useEffect(() => {
    const fetchRepositoryData = async () => {
      try {
        const response = await axios.get(reposUrl);
        setRepositoriesData(response.data);
      } catch (error) {
        console.error('Failed to fetch SBOM data:', error);
      }
    };

    fetchRepositoryData();
  }, [reposUrl]);

  return (
    <div>
      <label>
        <input
          type="radio"
          value="collapsed"
          checked={isCollapsed}
          onChange={() => setIsCollapsed(true)}
        />
        Collapsed
      </label>
      <label>
        <input
          type="radio"
          value="expanded"
          checked={!isCollapsed}
          onChange={() => setIsCollapsed(false)}
        />
        Expanded
      </label>

      {repositoriesData ? (
        <ReactJson
          src={repositoriesData}
          theme="monokai"
          
          collapsed={isCollapsed}
        />
      ) : (
        <div style={{ padding: '0.5rem 0' }}>
          <Skeleton.Text lines={3} lastWidth="55%" />
        </div>
      )}
    </div>
  );
};

export default RepositoriesView;
